import { render, staticRenderFns } from "./join-league-modal.vue?vue&type=template&id=a4647f5c&"
import script from "./join-league-modal.vue?vue&type=script&lang=js&"
export * from "./join-league-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports